import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Badge,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { FaEdit } from "react-icons/fa";
import EditModal from "./editModal";
import EmployeePersonal from "../EmployeeDetails/personal";
import EmployeeFamily from "../EmployeeDetails/family";
import EducationQualification from "../EmployeeDetails/edu_quali";
import WorkExperience from "../EmployeeDetails/work_exp";
import EmployeeAccount from "../EmployeeDetails/account";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeDropdown, fetchEmployeeViewProfileRequest } from "store/actions";
import { useLocation, useHistory } from "react-router-dom";
// image imports
// import user1 from "../../../assets/images/brands/user1.jpg";
import user1 from "../../../assets/images/brands/avatar1.png";
import empico1 from "../../../assets/images/brands/emp-ico-1.svg";
import empico2 from "../../../assets/images/brands/emp-ico-2.svg";
import empico3 from "../../../assets/images/brands/emp-ico-3.svg";
import empico4 from "../../../assets/images/brands/emp-ico-4.svg";
import empico5 from "../../../assets/images/brands/emp-ico-5.svg";
import empico6 from "../../../assets/images/brands/emp-ico-6.svg";
import empico7 from "../../../assets/images/brands/emp-ico-7.svg";
import empico8 from "../../../assets/images/brands/emp-ico-8.svg";
import edit from "../../../assets/images/brands/edit.svg";
import { decryptData, urlDecryptData } from "helpers/crypto_helper";
import TableContainer from "components/Common/TableContainer";
import { calculateExperience, formatDateWithOrdinal } from "common/dateFormat/formatDate";
import getAccessRights from "components/Common/getAccessRights";



const EmployeeProfile = () => {
  const location = useLocation();
  const [empID, setEmpID] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    dropdownData,
    profile,
    loading,
    error,
  } = useSelector((state) => ({
    dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? [],
    profile: state.EmployeeDetailsReducer?.profile ?? [],
    loading: state.EmployeeDetailsReducer?.loading,
    error: state.EmployeeDetailsReducer?.error,
  }));
  // const [filteredData, setFilteredData] = useState(data); 
  const [showEdit, setShowEdit] = useState(false);

  const history = useHistory();
  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
    console.log('accessRight > ', accessRight)
  }, [location]);

  const {
    emp_personel: personal = [],
    emp_shifts: shifts = [],
    emp_fathers: fathers = [],
    emp_mothers: mothers = [],
    emp_guardians: guardians = [],
    emp_marraiagestatus: marriageStatus = [],
    emp_childrens: childrens = [],
    emp_qualification: qualifications = [],
    emp_experience: experiences = [],
    emp_equipment: equipment = [],
    emp_document: documents = [],
    emp_skills: skills = [],
    emp_kr: keysResponsibilities = [],
  } = profile ?? {};

  // useEffect(() => {
  //   const authUserDetails = useAuthUserDetails();

  //   if (authUserDetails.length > 0) {
  //     setAuthDetails(authUserDetails[0]);
  //     const { unit_id, empid } = authUserDetails[0];
  //     dispatch(fetchEmployeeDropdown(unit_id));
  //   }

  //   const searchParams = new URLSearchParams(location.search);
  //   const encryptedId = searchParams.get("id");

  //   if (encryptedId) {
  //     // 🔒 Encrypted ID present → decrypt and enable edit mode
  //     try {
  //       const decryptedId = urlDecryptData(encryptedId);
  //       setEmpID(decryptedId);
  //       setIsEdit(true);
  //       setShowEdit(true); // ✅ Always show Edit if encrypted id exists
  //     } catch (error) {
  //       console.error("Failed to decrypt empID from URL:", error);
  //       setShowEdit(false);
  //     }
  //   } else if (authUserDetails.length > 0 && authUserDetails[0].empid) {
  //     // 👤 No encrypted id → use logged-in empid
  //     setEmpID(authUserDetails[0].empid);

  //     // ✅ Check profile for data_update_emp permission
  //     if (
  //       profile?.emp_personel?.[0]?.data_update_emp === "1" ||
  //       profile?.emp_personel?.[0]?.data_update_emp === 1
  //     ) {
  //       setShowEdit(true);
  //     } else {
  //       setShowEdit(false);
  //     }

  //     setIsEdit(false);
  //   }
  // }, [location.search, dispatch, profile,[]]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();

    if (authUserDetails.length > 0) {
      setAuthDetails(authUserDetails[0]);
      dispatch(fetchEmployeeDropdown(authUserDetails[0].unit_id));
    }
  }, [dispatch]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    const searchParams = new URLSearchParams(location.search);
    const encryptedId = searchParams.get("id");

    if (encryptedId) {
      try {
        const decryptedId = urlDecryptData(encryptedId);
        setEmpID(decryptedId);
        setIsEdit(true);
        setShowEdit(true);
      } catch (error) {
        console.error("Failed to decrypt empID:", error);
      }
    } else if (authUserDetails.length > 0 && authUserDetails[0].empid) {
      setEmpID(authUserDetails[0].empid);
      setIsEdit(false);
    }

    if (profile?.emp_personel?.[0]?.data_update_emp === "1" || profile?.emp_personel?.[0]?.data_update_emp === 1) {
      setShowEdit(true);
    } else {
      setShowEdit(false);
    }
  }, [location.search, profile]);

  useEffect(() => {
    if (empID) {
      dispatch(fetchEmployeeViewProfileRequest(empID));
    }
  }, [empID, dispatch]);


  const [open, setOpen] = useState("1"); // Default open section

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");
  const [Component, setComponent] = useState(null);

  const toggle = (id) => {
    setOpen(open === id ? "" : id);
  };

  // const toggleModal = () => {
  //    if (modalOpen && empID) {
  //     dispatch(fetchEmployeeViewProfileRequest(empID));
  //   }
  //   setModalOpen(!modalOpen);
  // };

  const toggleModal = () => {
    console.log('toggleModal called. modalOpen:', modalOpen);
    if (modalOpen) {
      closeModal();
    }
  };


  // Function to open the modal with the respective component
  // const handleEditClick = (section) => {
  //   setSelectedSection(section);
  //   setModalOpen(true);

  //   switch (section) {
  //     case "Basic Information":
  //       setComponent(() => EmployeePersonal);
  //       break;
  //     case "Family Information":
  //       setComponent(() => EmployeeFamily);
  //       break;
  //     case "Bank Information":
  //       setComponent(() => EmployeeAccount);
  //       break;
  //     case "Education Information":
  //       setComponent(() => EducationQualification);
  //       break;
  //     case "Experience Information":
  //       setComponent(() => WorkExperience);
  //       break;
  //     default:
  //       setComponent(null);
  //   }
  // };

  const closeModal = () => {
    setModalOpen(false);
    setComponent(null);
    setSelectedSection("");

    if (empID) {
      dispatch(fetchEmployeeViewProfileRequest(empID));
    }
  };


  const handleEditClick = (section) => {
    setSelectedSection(section);
    setModalOpen(true);
    // const closeModal = () => {
    //   setModalOpen(false);
    //   if (empID) {
    //     dispatch(fetchEmployeeViewProfileRequest(empID));
    //   }
    // };
    const refreshData = () => {
      // if (empID) {
      //   dispatch(fetchEmployeeViewProfileRequest(empID));
      // }
      closeModal();
    };

    const isActive = true;

    switch (section) {
      case "Basic Information": {
        const PersonalComponent = () => (
          <EmployeePersonal empID={empID} dropdownData={dropdownData} isActive={isActive} onSuccess={refreshData} />
        );
        PersonalComponent.displayName = "EmployeePersonalComponent";
        setComponent(() => PersonalComponent);
        break;
      }

      case "Family Information": {
        const FamilyComponent = () => (
          <EmployeeFamily empID={empID} authDetails={authDetails} dropdownData={dropdownData} isActive={isActive} onSuccess={refreshData} />
        );
        FamilyComponent.displayName = "EmployeeFamilyComponent";
        setComponent(() => FamilyComponent);
        break;
      }

      case "Bank Information": {
        const AccountComponent = () => (
          <EmployeeAccount empID={empID} authDetails={authDetails} isActive={isActive} />
        );
        AccountComponent.displayName = "EmployeeAccountComponent";
        setComponent(() => AccountComponent);
        break;
      }

      case "Education Information": {
        const EducationComponent = () => (
          <EducationQualification empID={empID} authDetails={authDetails} isActive={isActive} />
        );
        EducationComponent.displayName = "EducationQualificationComponent";
        setComponent(() => EducationComponent);
        break;
      }

      case "Experience Information": {
        const ExperienceComponent = () => (
          <WorkExperience empID={empID} authDetails={authDetails} isActive={isActive} />
        );
        ExperienceComponent.displayName = "WorkExperienceComponent";
        setComponent(() => ExperienceComponent);
        break;
      }

      default:
        setComponent(null);
    }
  };

  const education_columns = useMemo(
    () => [
      { Header: "S.No", className: "serial-no", applyHeaderClass: true, Cell: ({ row }) => qualifications.length - row.index },
      { Header: "Qualification", accessor: "qualify_name" },
      { Header: "University", accessor: "university" },
      { Header: "Course", accessor: "stream" },
      { Header: "Year", accessor: "year" },
      { Header: "Percentage", accessor: "per_cgpa" },
      { Header: "Mode", accessor: "mode_study" },
      { Header: "Reference No", accessor: "reference_no" },
    ],
    [qualifications]
  );

  const experi_columns = useMemo(
    () => [
      { Header: "S.No", className: "serial-no", applyHeaderClass: true, Cell: ({ row }) => experiences.length - row.index },
      { Header: "Company Name", accessor: "company_name" },
      { Header: "Designation", accessor: "designation" },
      { Header: "Reported To", accessor: "reported_to" },
      { Header: "From Date", accessor: "from_dt" },
      { Header: "To Date", accessor: "till_dt" },
      // { Header: "Years", accessor: "exp_yrs" },

      { Header: "Reason For Change", accessor: "reason_change" },
    ],
    [experiences]
  );

  const skills_columns = useMemo(
    () => [
      { Header: "S.No", className: "serial-no", applyHeaderClass: true, Cell: ({ row }) => skills.length - row.index },
      { Header: "Skill Name", accessor: "skill_name" },
      { Header: "Description", accessor: "description" },
    ],
    [skills]
  );

  const keysResponsibilities_columns = useMemo(
    () => [
      { Header: "S.No", className: "serial-no", applyHeaderClass: true, Cell: ({ row }) => keysResponsibilities.length - row.index },
      { Header: "Keys and Responsibilities", accessor: "kr" },
    ],
    [keysResponsibilities]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Employee" breadcrumbItem={isEdit ? "View Profile" : "My Profile"} />
          <Row className="gy-4">  {/* Add vertical spacing */}
            <Col lg="12">
              <Row className="gx-5"> {/* Add horizontal spacing */}
                {/* Left Section - Employee Details */}
                <Col className="px-3 employee-detail-lft col-xl-4 col-12"> {/* Added padding for spacing */}
                  <Card className=" shadow card-bg-1">
                    <CardBody className="p-0">
                      <span className="avatar avatar-90 avatar-rounded m-auto d-flex overflow-hidden">
                        <img
                          src={personal[0]?.image_url ? personal[0]?.image_url : user1}
                          className="w-100 h-100 object-fit-cover rounded-circle"
                          alt="thumbnail"
                          style={{
                            objectPosition: "center top", // focus on face area
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = user1;
                          }}
                        />
                      </span>
                      <div className="text-center px-3 pb-3 border-bottom">
                        <div className="mb-4">
                          <h5 className="d-flex justify-content-center">{personal[0]?.salutationname} {personal[0]?.first_name}</h5>
                          <span className="badge badge-soft-dark fw-medium me-2 mb-2">{personal[0]?.category}</span>
                          <span className="badge badge-soft-secondary fw-medium">{calculateExperience(personal[0]?.doj)}</span>
                        </div>
                        {/* employee details */}
                        <div className="emp-detail">
                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center title-text">
                              <span className="d-inline-flex"><img src={empico1} alt="thumbnail" /></span>
                              Employee No.
                            </div>
                            <p>{personal[0]?.emp_no}</p>
                          </div>
                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex"><img src={empico2} alt="thumbnail" /></span>
                              Team
                            </div>
                            <p>{personal[0]?.department}</p>
                          </div>
                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex"><img src={empico3} alt="thumbnail" /></span>
                              Date of Joining
                            </div>
                            <p>{formatDateWithOrdinal(personal[0]?.doj)}</p>
                          </div>
                          <div className="d-flex justify-content-between list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex"><img src={empico3} alt="thumbnail" /></span>
                              Reporting To
                            </div>
                            <p>{personal[0]?.reporting}</p>
                          </div>
                        </div>
                        {/* <div className="row gx-2 mt-3">
                          <div className="col-12">
                            <div>
                              <Button className=" btn btn-info w-100" block>
                                Edit Information
                              </Button>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className="p-3">
                        <div className="emp-detail mt-1">
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6>Basic information</h6>
                            {showEdit && (
                              <img src={edit} alt="thumbnail" onClick={() => handleEditClick("Basic Information")} className="text-muted cursor-pointer edit-icon" />
                            )}
                          </div>

                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex align-items-center"><img src={empico4} alt="thumbnail" /></span>{" "}
                              Phone
                            </div>
                            <a href="tel:+9195878525874" className="text-mail">
                              {personal[0]?.per_mobile}
                            </a>
                          </div>

                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex align-items-center"><img src={empico5} alt="thumbnail" /></span>{" "}
                              Email
                            </div>
                            <a href="mailto:ramachandran@aescorp.in" className="text-mail">
                              {personal[0]?.work_email}
                            </a>
                          </div>

                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex align-items-center"><img src={empico6} alt="thumbnail" /></span>
                              Gender
                            </div>
                            {personal[0]?.gender_name}
                          </div>

                          <div className="d-flex justify-content-between mb-2 list-div">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex align-items-center"><img src={empico7} alt="thumbnail" /></span>
                              Birthday
                            </div>
                            {formatDateWithOrdinal(personal[0]?.dob)}
                          </div>

                          <div className="d-flex justify-content-between mb-2 list-div align-items-start">
                            <div className="d-inline-flex align-items-center">
                              <span className="d-inline-flex align-items-center"><img src={empico8} alt="thumbnail" /></span>
                              Address
                            </div>
                            <p className="text-end">
                              {personal[0]?.address_lane1}<br />
                              {personal[0]?.address_lane2}<br />
                              {personal[0]?.address_lane3}
                              {personal[0]?.per_place}-{personal[0]?.per_postalcode}<br />
                              {personal[0]?.per_state}, {personal[0]?.per_country}
                            </p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Right Section - Details Accordion */}
                <Col className="px-3 col-xl-8 col-12"> {/* Added padding for spacing */}
                  <Accordion open={open} toggle={toggle} className="w-100 custom-accordion">
                    {/* Personal Information */}
                    <AccordionItem className="mb-3"> {/* Added margin for spacing */}
                      <AccordionHeader targetId="1" className="accordion-header-custom p-0 card-header ">
                        <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                          <h5>Personal Information</h5>
                          {showEdit && (
                            <img src={edit} alt="thumbnail" onClick={() => handleEditClick("Basic Information")} className="text-muted cursor-pointer edit-icon" />
                          )}
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="info-detail">
                          <ul>
                            <li>
                              <h5>Aadhaar</h5>
                              <p>{personal[0]?.adhar_no}</p>
                            </li>
                            <li>
                              <h5>PAN</h5>
                              <p>{personal[0]?.pan_no}</p>
                            </li>
                            <li>
                              <h5>UAN</h5>
                              <p>{personal[0]?.uan_no}</p>
                            </li>
                            <li>
                              <h5>Blood Group</h5>
                              <p>{personal[0]?.blood_group}</p>
                            </li>
                            <li>
                              <h5>State</h5>
                              <p>{personal[0]?.present_per_state}</p>
                            </li>
                            <li>
                              <h5>Nationality</h5>
                              <p>{personal[0]?.nationality}</p>
                            </li>
                            <li>
                              <h5>Marital status</h5>
                              <p>
                                {
                                  marriageStatus?.length > 0
                                    ? (marriageStatus[0]?.maritial_status === "1" ? "Single" : "Married")
                                    : "Not Available"
                                }
                              </p>
                            </li>
                            {/* <li>
                              <h5>Religion</h5>
                              <p>Hindu</p>
                            </li> */}
                          </ul>
                        </div>
                      </AccordionBody>
                    </AccordionItem>

                    {/* Family Information */}
                    <AccordionItem className="mb-3"> {/* Added margin for spacing */}
                      <AccordionHeader targetId="2" className="accordion-header-custom card-header p-0">
                        <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                          <h5>Family Information</h5>
                          {showEdit && (
                            <img src={edit} alt="thumbnail" onClick={() => handleEditClick("Family Information")} className="text-muted cursor-pointer edit-icon" />
                          )}
                        </div></AccordionHeader>
                      <AccordionBody accordionId="2">
                        <div className="info-detail">
                          <ul>
                            <li>
                              <h5>Father</h5>
                              <p>{fathers[0]?.father_name}</p>
                            </li>
                            <li>
                              <h5>Mother</h5>
                              <p>{mothers[0]?.mother_name}</p>
                            </li>
                            <li>
                              <h5>Spouse</h5>
                              <p>{marriageStatus[0]?.spouse_name}</p>
                            </li>
                            <li>
                              <h5>Guardian</h5>
                              <p>{guardians[0]?.guardian_name}</p>
                            </li>
                            <li>
                              <h5>Emergency Contact</h5>
                              <p>{personal[0]?.emerency_contact_person}</p>
                            </li>
                            <li>
                              <h5>Emergency Contact Number</h5>
                              <p>{personal[0]?.emerency_contact_no}</p>
                            </li>
                          </ul>
                        </div>
                      </AccordionBody>
                    </AccordionItem>

                    {/* Bank Information */}
                    <AccordionItem className="mb-3"> {/* Added margin for spacing */}
                      <AccordionHeader targetId="3" className="accordion-header-custom card-header p-0">
                        <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                          <h5>Bank Information</h5>
                          {/* <img src={edit} alt="thumbnail" onClick={() => handleEditClick("Bank Information")} className="text-muted cursor-pointer edit-icon" /> */}
                        </div></AccordionHeader>
                      <AccordionBody accordionId="3">
                        <div className="info-detail">
                          <ul>
                            <li>
                              <h5>A/C Holder Name</h5>
                              <p>{personal[0]?.acc_holder_name}</p>
                            </li>
                            <li>
                              <h5>A/C Number</h5>
                              <p>{personal[0]?.bank_acno}</p>
                            </li>
                            <li>
                              <h5>Bank Name</h5>
                              <p>{personal[0]?.bank_name}</p>
                            </li>
                            <li>
                              <h5>Branch</h5>
                              <p>{personal[0]?.branch}</p>
                            </li>
                            <li>
                              <h5>IFSC Code</h5>
                              <p>{personal[0]?.ifsc_code}</p>
                            </li>
                            <li>
                              <h5>ESI No</h5>
                              <p>{personal[0]?.esi_no}</p>
                            </li>
                            <li>
                              <h5>EPF No</h5>
                              <p>{personal[0]?.epf_no}</p>
                            </li>
                            <li>
                            </li>
                            {/* <li>
                              <h5>Salary Account</h5>
                              <p>Yes</p>
                            </li>
                            <li>
                              <h5>Account Type</h5>
                              <p>Savings</p>
                            </li> */}
                          </ul>
                        </div>
                      </AccordionBody>
                    </AccordionItem>

                    <Row>
                      <Col md="12">
                        <AccordionItem className="mb-3 two-column-accordian">
                          <AccordionHeader targetId="4" className="accordion-header-custom card-header p-0">
                            <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                              <h5>Education Details</h5>
                              {showEdit && (
                                <img src={edit} alt="thumbnail" onClick={() => handleEditClick("Education Information")} className="text-muted cursor-pointer edit-icon" />
                              )}
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId="4">
                            {/* <div className="info-detail">
                              <ul>
                                <li>
                                  <h5>Highest Qualification</h5>
                                  <p>Master’s in Computer Science</p>
                                </li>
                                <li>
                                  <h5>University</h5>
                                  <p>Anna University</p>
                                </li>
                                <li>
                                  <h5>Year of Passing</h5>
                                  <p>2012</p>
                                </li>
                                <li>
                                  <h5>Specialization</h5>
                                  <p>Software Engineering</p>
                                </li>
                                <li>
                                  <h5>Additional Certifications</h5>
                                  <p>AWS Certified Developer</p>
                                </li>
                              </ul>
                            </div> */}
                            <Row>
                              <Col md={12}>
                                <TableContainer
                                  columns={education_columns}
                                  data={qualifications.length > 0 ? qualifications : []}
                                  isGlobalFilter={true}
                                  customPageSize={10}
                                />
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                      </Col>
                      <Col md="12">
                        <AccordionItem className="mb-3 two-column-accordian">
                          <AccordionHeader targetId="5" className="accordion-header-custom card-header p-0">
                            <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                              <h5>Experience</h5>
                              {showEdit && (
                                <img src={edit} alt="thumbnail" onClick={() => handleEditClick("Experience Information")} className="text-muted cursor-pointer edit-icon" />
                              )}
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId="5">
                            {/* <div className="info-detail">
                              <ul>
                                <li>
                                  <h5>Total Experience</h5>
                                  <p>10+ years</p>
                                </li>
                                <li>
                                  <h5>Designation</h5>
                                  <p>Senior Software Developer</p>
                                </li>
                                <li>
                                  <h5>Date Of Joining</h5>
                                  <p>20th July 2014</p>
                                </li>
                                <li>
                                  <h5>Previous Company</h5>
                                  <p>XYZ Solutions</p>
                                </li>
                                <li>
                                  <h5>Key Skills</h5>
                                  <p>React, Node.js, AWS, Docker, Kubernetes</p>
                                </li>
                              </ul>
                            </div> */}
                            <Row>
                              <Col md={12}>
                                <TableContainer
                                  columns={experi_columns}
                                  data={experiences.length > 0 ? experiences : []}
                                  isGlobalFilter={true}
                                  customPageSize={10}
                                />
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                      </Col>
                      <Col md="12">
                        <AccordionItem className="mb-3 two-column-accordian">
                          <AccordionHeader targetId="6" className="accordion-header-custom card-header p-0">
                            <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                              <h5>Skills</h5>
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId="6">
                            <Row>
                              <Col md={12}>
                                <TableContainer
                                  columns={skills_columns}
                                  data={skills.length > 0 ? skills : []}
                                  isGlobalFilter={true}
                                  customPageSize={10}
                                />
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                      </Col>
                      <Col md="12">
                        <AccordionItem className="mb-3 two-column-accordian">
                          <AccordionHeader targetId="7" className="accordion-header-custom card-header p-0">
                            <div className=" d-flex align-items-center flex-fill justify-content-between me-2" >
                              <h5>Keys and Responsibilities</h5>
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId="7">
                            <Row>
                              <Col md={12}>
                                <TableContainer
                                  columns={keysResponsibilities_columns}
                                  data={keysResponsibilities.length > 0 ? keysResponsibilities : []}
                                  isGlobalFilter={true}
                                  customPageSize={10}
                                />
                              </Col>
                            </Row>
                          </AccordionBody>
                        </AccordionItem>
                      </Col>
                    </Row>
                  </Accordion>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div >

      {/* Modal for Editing */}
      < EditModal
        isOpen={modalOpen}
        toggle={toggleModal}
        section={selectedSection}
        Component={Component}
        dropdownData={dropdownData}
      />
    </React.Fragment >
  );
};

export default EmployeeProfile;
